import { render, staticRenderFns } from "./walletList.vue?vue&type=template&id=355128eb&scoped=true&"
import script from "./walletList.vue?vue&type=script&lang=js&"
export * from "./walletList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355128eb",
  null
  
)

export default component.exports